import { Link } from "react-router-dom";

export default function GameModes() {
    
    return (
        <div className="gamemodes">
            <h1>Single Player</h1>
            <div>
                <Link className="mode" to={'/single/standard'}>
                    <h2>Standard</h2>
                    <p>Test how many songs you get right in a fixed amount of songs</p>
                </Link>
                <Link className="mode" to={'/single/endless'}>
                    <h2>Endless</h2>
                    <p>”Time is no problem for me” <br/> How many points can you get until you run out of lives?</p>
                </Link>
                <Link className="mode" to={'/single/hardcore'}>
                    <h2>Hardcore</h2>
                    <p>”I'm the ultimate fan” <br/> The ultimate test. No lives. Get it wrong and you lose</p>
                </Link>
            </div>
        </div>
    )
}